import { createTheme } from '@mui/material/styles';
import type {} from '@mui/x-date-pickers/themeAugmentation';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#647ee8',
      light: '#D3E3FD',
      dark: '#3f51b5',
    },
    secondary: {
      main: '#f2f2f2',
      light: '#fbfbfb',
      dark: '#ececec',
    },
    error: {
      main: '#d32f2f',
    },
    text: {
      primary: '#606060',
      secondary: '#808080',
    },
  },
  typography: {
    fontFamily: '"Inter Variable", Inter, sans-serif',
    h1: { color: '#404040', fontWeight: 400 },
    h2: { color: '#404040', fontWeight: 400 },
    h3: { color: '#404040', fontWeight: 400 },
    h4: { color: '#404040', fontWeight: 400 },
    h5: { color: '#404040', fontWeight: 400 },
    h6: { color: '#404040', fontWeight: 400 },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        size: 'small',
      },
    },
    MuiFormControl: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiButton: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        containedPrimary: {
          color: '#ffffff',
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiDatePicker: {
      defaultProps: {
        slotProps: {
          textField: {
            size: 'small',
          },
        },
      },
    },
    MuiOutlinedInput: {},
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&.MuiTableRow-hover:hover': {
            backgroundColor: '#f8fafc',
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#f1f5f9',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          border: 'none',
        },
        standardInfo: {
          backgroundColor: '#E8EFFD',
          color: '#606060',
          '& .MuiAlert-icon': {
            color: '#647ee8',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          border: 'none',
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          border: 'none',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)',
        },
      },
    },
    MuiIcon: {
      styleOverrides: {
        root: {
          color: '#808080',
        },
      },
    },
  },
});
